/* eslint-disable */
<i18n>
de:
  Get directions: Route berechnen
  Public transport (new): Öffentliche Verkehrsmittel
  Heide-Shuttle Connections: Heide-Shuttle
  Bicycle (fastest): Fahrrad (schnellste Route)
  Bicycle (shortest distance): Fahrrad (kürzeste Route)
  Pedestrian: Fußgänger
  Car (shortest distance): Auto (kürzeste Route)
  Car (fastest): Auto (schnellste Route)
  Mode: Verkehrsmittel
  from: von
  to: nach
  via: über
  Remove stop: Zwischenstop entfernen
  Add stop: Zwischenstop hinzufügen
  Sorry, you can specify a time, or multiple waypoints, but not both.: Leider können Sie eine Zeit oder mehrere Wegpunkte angeben, aber nicht beides.
  Sorry, directions are currently unavailable.: Eine Wegbeschreibung ist derzeit leider nicht verfügbar.
  No route found. Please try other options.: Es wurde keine Route gefunden. Bitte versuchen Sie es mit anderen Einstellungen.
  Find place: Ort suchen
</i18n>

<template>
  <v-navigation-drawer
      v-model="drawerOpen"
      :value="drawerOpen"
      :dark="dark"
      width="350"
      hide-overlay
      disable-resize-watcher
      disable-route-watcher
      absolute
      stateless
      height="unset"
      :right="right"
      temporary
      :class="{'hide-drawer': drawerOpen === false}"
      style="z-index: 3; box-shadow: unset;"
      class="unset-height"
  >
    <v-card class="pb-2">
      <v-toolbar :color="color" class="" :dark="dark">
        <v-toolbar-side-icon><v-icon>{{icon}}</v-icon></v-toolbar-side-icon>
        <v-toolbar-title class="wgu-win-title">{{ $t('Get directions') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-side-icon @click="closePanel"><v-icon>close</v-icon></v-toolbar-side-icon>
      </v-toolbar>

      <div style="overflow:auto; height: calc(100vh - 165px)">
      <v-form>
        <v-select
          :items="transportModes"
          v-model="transportMode"
          :label="$t('Mode')"
          class="mt-4 px-2"
          box
          prepend-icon="mode_of_travel"
        ></v-select>
        <DestinationSelector
          :label="$t('from')"
          @change="from = $event"
          ref="fromSelector"
          :localSuggestions="localSuggestions"/>
        <DestinationSelector
          v-for="(waypoint, i) in waypoints"
          label="via"
          @change="$set(waypoints, i, $event)"
          :localSuggestions="localSuggestions"
          :key="i"
          :ref="`way${i}selector`"
        />
        <v-btn color="primary" class="d-block mx-auto mb-4 mt-0" outline flat
          v-if="from && to && (waypoints.length === 0 || waypoints.length <= 8 && waypoints.slice(-1)[0])" @click="waypoints.push(undefined)">
          {{ $t('Add stop') }}
        </v-btn>
        <v-btn color="primary" class="d-block mx-auto mb-4 mt-0" outline flat v-if="waypoints.length" @click="waypoints.splice(-1)">{{ $t('Remove stop') }}</v-btn>
        <DestinationSelector
          :label="$t('to')"
          @change="toChange"
          ref="toSelector"
          :localSuggestions="localSuggestions"/>
        <div v-if="transportMode.match(/fastest;publicTransport|transit|bus/)">
          <DateTimePicker @change="timeDate=$event"/>
        </div>
        <v-container justify-center="true">
          <v-btn class="d-block mx-auto " color="primary" @click="search" v-if="from && to && !(timeDate.time && timeDate.timeIsInvalid)">
            {{ $t('Get directions') }}
          </v-btn>
        </v-container>
        <v-alert :value="errorMessage" outline type="error" class="ma-3">
          {{ $t(errorMessage) }}
        </v-alert>
        <DownloadGPX :routeGeometry="routeGeometry" :transportMode="transportMode" />
        <RoutingInstructions v-if="route" :route="route" :dateSpecified="timeDate.isDateSpecified" :transportModeTitle="responseTransportMode"/>
      </v-form>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>

import axios from 'axios';
import { WguEventBus } from '../../WguEventBus.js';
import DestinationSelector from './DestinationSelector';
import RoutingInstructions from './RoutingInstructions';
import DateTimePicker from './DateTimePicker';
import DownloadGPX from './DownloadGPX'
import { getRouteV7, getRouteV8 } from './hereRoutingApi';
import { featureCollection, point } from './routingUtils';
export default {
  name: 'wgu-routing-panel',
  directives: {
  },
  props: {
    right: {type: Boolean, required: false, default: false},
    width: {type: Number, required: false, default: 360},
    height: {type: String, required: false, default: '100%'},
    icon: {type: String, required: false, default: 'directions'},
    dark: {type: Boolean, required: false, default: false},
    color: {type: String, required: false, default: 'red darken-3'},
    active: {type: Boolean, required: false, default: false},
    options: { type: Object, required: false, default: {} },
    toggleGroup: {type: String, required: false, default: undefined}
  },
  components: {
    DestinationSelector, // The autocomplete component with places to route to/from
    RoutingInstructions, // Shows the instructions as returned by the routing API
    DateTimePicker, // Allows choosing departure/arrival time and optionally date, for public transit trips
    DownloadGPX
  },
  data () {
    return {
      moduleName: 'wgu-routing',
      drawerOpen: this.active,
      from: undefined,
      to: undefined,
      waypoints: [],
      localSuggestions: [],
      transportMode: 'transit',
      errorMessage: undefined,
      dev: location.hash.match(/dev/),
      routeGeometry: undefined,
      stopsGeometry: undefined,
      boundingBox: undefined,
      route: undefined,
      timeDate: {}
    }
  },
  async mounted () {
    this.loadLocalSuggestions()
    window.RoutingPanel = this;
    WguEventBus.$on('toggle-routing-panel', state => {
      this.drawerOpen = state === undefined ? !this.drawerOpen : state;
    });
    WguEventBus.$on('directions-to-feature', feature => {
      this.drawerOpen = true;
      if (this.toggleGroup) {
        WguEventBus.$emit(this.toggleGroup, { moduleName: this.moduleName, state: this.drawerOpen });
      }
      this.$refs.toSelector.setTargetById(feature.get('id'));
    });

    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      WguEventBus.$on(this.toggleGroup, ({ moduleName, state }) => {
        this.drawerOpen = moduleName === this.moduleName && state;
      });
    }
  },
  computed: {
    transportModes () {
      // transportOptions is an array of strings which are treated as regexes: 'car' matches car-fast or car-short
      const matchesOptions = value => (this.options.transportModes || []).find(modeTest => value.match(modeTest))
      return [
        {
          text: this.$t('Car (fastest)'),
          value: 'car-fast'
        }, {
          text: this.$t('Car (shortest distance)'),
          value: 'car-short'
        }, {
          text: this.$t('Public transport (new)'),
          value: 'transit'
        }, {
          text: this.$t('Heide-Shuttle Connections'),
          value: 'bus'
        }, {
          text: this.$t('Public transport (old)'),
          value: 'fastest;publicTransport'
        }, {
          text: this.$t('Bicycle (fastest)'),
          value: 'fastest;bicycle'
        }, {
          text: this.$t('Bicycle (shortest distance)'),
          value: 'shortest;bicycle'
        }, {
          text: this.$t('Pedestrian'),
          value: 'shortest;pedestrian'
        }
      ].filter(({ value }) => matchesOptions(value))
    },
    // when anything changes that was used to calculate the route, we clear the route
    routeParameters () {
      return [this.from, this.to, this.waypoints.map(w => w && w.geometry.coordinates), this.transportMode, this.timeDate.timeMode, this.timeDate.time, Date.now()];
    },
    waypointsGeometry () {
      return this.waypoints.filter(w => w && w.geometry && w.geometry.coordinates);
    },
    allGeometry () {
      return [this.from && this.from.geometry.coordinates, this.waypoints.map(w => w && w.geometry.coordinates), this.to && this.to.geometry.coordinates, this.routeGeometry];
    },
    responseTransportMode () {
      if (!this.route || !this.route.mode || !this.route.mode.transportModes) {
        return this.transportMode.match(/^car/) ? 'Driving' : 'Public transport';
      } else {
        return {
          'transit': 'Public transport',
          'publicTransport': 'Public transport',
          'publicTransportTimeTable': 'Public transport',
          'bicycle': 'Bicycle',
          'pedestrian': 'Walking'
        }[this.route.mode.transportModes[0]]
      }
    },
    boundingBoxForStops () {
      let bbox;
      const stops = [this.from && this.from.geometry.coordinates, ...this.waypoints.map(w => w && w.geometry.coordinates), this.to && this.to.geometry.coordinates];
      for (let stop of stops) {
        if (stop) {
          bbox = bbox || [...stop, ...stop];
          bbox[0] = Math.min(bbox[0], stop[0]);
          bbox[1] = Math.min(bbox[1], stop[1]);
          bbox[2] = Math.max(bbox[2], stop[0]);
          bbox[3] = Math.max(bbox[3], stop[1]);
        }
      }
      return bbox;
    }
  },
  watch: {
    routeParameters () {
      this.route = undefined;
      this.routeGeometry = undefined;
      this.stopsGeometry = undefined;
      this.boundingBox = undefined;
    },
    allGeometry () {
      WguEventBus.$emit('route-update', {
        routeGeometry: this.routeGeometry,
        startGeometry: this.from && this.from.geometry.coordinates ? point(this.from.geometry.coordinates) : undefined,
        waypointsGeometry: featureCollection(this.waypointsGeometry),
        endGeometry: this.to && this.to.geometry.coordinates ? point(this.to.geometry.coordinates) : undefined,
        stopsGeometry: this.stopsGeometry,
        boundingBox: this.boundingBox || this.boundingBoxForStops
      });
    },
    route () {
      if (this.route) {
        this.$nextTick(() => document.getElementById('route').scrollIntoView({ behavior: 'smooth' }));
      } else {
        this.routeGeometry = undefined;
      }
    },
    drawerOpen () {
      // I'm undecided whether the panel should reset when it opens. There isn't another good way to clear it.
      // OTOH, it could take a while to set up all the parameters they want for the search, then they lose it all
      // because they temporarily went to the layers panel.
      // this.$refs.fromSelector.target = undefined;
      // this.showDirectionsControls = false;
    }
  },
  methods: {
    loadLocalSuggestions () {
      WguEventBus.$on('ol-map-rendered', async () => {
        // Find layers that have been marked 'routable' in app config, and use them as routing targets
        const layerUrls = this.$map.getLayers().getArray()
          .filter(l => l.getProperties().routable)
          .map(l => l.getSource().getUrl());
        const featureCollections = await Promise.all(layerUrls.map(axios.get));
        const localSuggestions = []
        for (const { data } of featureCollections) {
          localSuggestions.push(...data.features.map(poi => ({ text: poi.properties.name, value: poi, source: 'local' })));
        }
        localSuggestions.sort((a, b) => (a.text < b.text ? -1 : 1));
        this.localSuggestions = localSuggestions;
      });
    },
    toChange (newTo) {
      this.to = newTo;
    },
    async search () {
      this.errorMessage = undefined;
      this.route = undefined;
      if (this.transportMode.match(/^car|transit|bus/)) {
        return this.getRouteV8();
      } else {
        return this.getRouteV7();
      }
    },
    async getRouteV8 () {
      const response = await getRouteV8({
        from: this.from,
        waypoints: this.waypoints,
        to: this.to,
        transportMode: this.transportMode,
        timeDate: this.timeDate,
        locale: this.$i18n.locale,
        extraAttributes: this.options.modeAttributes && this.options.modeAttributes[this.transportMode]
      });
      if (response !== 'No route found.') {
        this.route = response.route;
        this.routeGeometry = response.routeGeometry;
        this.stopsGeometry = response.stopsGeometry;
      } else {
        this.errorMessage = this.$t('No route found. Please try other options.')
      }
    },
    async getRouteV7 () {
      const response = await getRouteV7({
        from: this.from,
        waypoints: this.waypoints,
        to: this.to,
        transportMode: this.transportMode,
        timeDate: this.timeDate,
        locale: this.$i18n.locale,
        extraAttributes: this.options.modeAttributes && this.options.modeAttributes[this.transportMode]
      });

      if (response.errorMessage) {
        this.errorMessage = response.errorMessage;
      } else {
        this.route = response.route;
        this.boundingBox = response.boundingBox;
        this.routeGeometry = response.routeGeometry;
        this.stopsGeometry = response.stopsGeometry;
      }
    },
    closePanel: function () {
      if (this.drawerOpen === false) {
        // Already closed
        return;
      }
      this.drawerOpen = false;
      WguEventBus.$emit('close-direction-menu', this.drawerOpen);
    }
  }
}
</script>

<style>
.hide-drawer{
  width: 0 !important;
}
@media (max-width: 960px) {
    .unset-height{
        height: 100% !important;
      }
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/routing/RoutingPanel.vue